// extracted by mini-css-extract-plugin
export default {"mobilePrimaryNav":"mobilePrimaryNav__bxXrl","hideContentOnScroll":"hideContentOnScroll__fZDtm"};